import React, { useState ,useEffect} from "react";
import OTPInput from "otp-input-react";

const VerificationOtp = ({ verificationCode, setVerificationCode }) => {
  const handleChange = (otp) => {
    setVerificationCode(otp);
  
  };


 
  return (
    <>
      <OTPInput
        value={verificationCode}
        onChange={handleChange}
        autoFocus
        OTPLength={6}
        otpType="number"
        name="verification_code"
        disabled={false}
        className="otpinput pt-4"
        containerStyle={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          maxWidth: "100%",
        }}
      />
    </>
  );
};

export default VerificationOtp;
